export default "__VITE_ASSET__StnOBGpZ__"